<script>
import modelBypassMixin from '@/utils/model-bypass-mixin'
import checkoutMixin from '@/v-shop/checkout/checkout-mixin'

export default {
	mixins: [modelBypassMixin(String, null), checkoutMixin],
	props: {
		selector: Object,
	},
	data() {
		return {
			selected: null,
		}
	},
	watch: {
		selected(newVal) {
			this.iValue = newVal
			this.$emit('canSubmit', !!newVal)
		},
	},
	computed: {
		plans() {
			return this.selector.checkoutData || []
		},
		sign() {
			return this.checkout.order.currency.sign
		},
	},
}
</script>

<template>
	<div>
		<div>Seleccioná el plan de pago</div>
		<div>Las cuotas serán descontadas del afiliado de TvMutual</div>
		<div class="payment-options-box">
			<v-radio-group v-model="selected" class="font-1 ma-0 pa-0" hide-details>
				<div v-for="plan in plans" :key="plan.hash" class="payment-option-box">
					<!-- <pre>{{ plan }}</pre> -->
					<div
						@click="selected = plan.hash"
						class="payment-option-item d-flex align-center payment-option-item--selectable"
						:class="{ 'payment-option-item--selected': plan.hash == selected }"
					>
						<v-radio :value="plan.hash" class="font-1 ma-0 pa-0" />
						<div>
							<div>{{ plan.title }}</div>
							<div class="grey--text mb-1">{{ plan.description }}</div>
							<div class="d-flex align-center">
								<PriceText :amount="plan.total" :currency="sign" :sup-decimals="false" />,
								<span>{{ plan.qty }} cuotas de</span>
								<PriceText
									:amount="plan.installmentsAmount"
									:currency="sign"
									:sup-decimals="false"
									class="ml-1"
								/>
							</div>
							<div class="d-flex align-center">
								<span>Recargo: </span>
								<PriceText
									:amount="plan.surcharge"
									:currency="sign"
									:sup-decimals="false"
									class="mx-1"
								/>
								<span>({{ plan.surchargePct }}%)</span>
							</div>
						</div>
					</div>
				</div>
			</v-radio-group>
		</div>
	</div>
</template>

<style scoped lang="scss">
.payment-options-box {
	border-radius: 8px;
	border: 1px solid #ccc;
	border-top: none;
	margin: 12px 0px 24px;
	overflow: hidden;
}
.payment-option-item {
	.v-radio {
		position: relative;
		top: 5px;
		margin-bottom: 0 !important;
	}
	background-color: #fff;
	padding: 12px 16px 12px 12px;
	border-left: 4px solid #ccc;
	cursor: pointer;
	border-top: 1px solid #bbb;
	&:hover {
		background-color: #f9f9f9;
		border-left: 4px solid #aaa;
	}
	&--selected {
		background-color: #f5f5f5 !important;
		border-left: 4px solid var(--link) !important;
	}
}
</style>

